import BaseField from "./BaseField";

export class UploadField extends BaseField{
    constructor(props) {
        super(props);
        this.state = {
            wrongFormat: false,
            sizeTooBig: false,
            tooManyFiles: false,
        }
        this.getIcon = this.getIcon.bind(this);
        this.dropHandler = this.dropHandler.bind(this);
        this.renderUploadedFiles = this.renderUploadedFiles.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.fileUploadAllowed = this.fileUploadAllowed.bind(this);
    }

    getIcon(){
        if(this.props.IconURL !== ''){
            return (
                <div className="image__holder mx-auto">
                    <img src={this.props.IconURL} alt="UploadImage" className="img-fluid"/>
                </div>
            )
        } else if(this.props.IconClass !== ''){
            return (
                <i className={this.props.IconClass}/>
            )
        }
        return null
    }

    dropHandler(e){
        e.preventDefault();
        if(e.dataTransfer.items){
            [...e.dataTransfer.items].forEach((item, i) => {
                if(item.kind === 'file') {
                    const file = item.getAsFile();
                    this.handleFile(file);
                }
            })
        }
    }

    onDragOver(e) {
        e.preventDefault();
    }

    deleteFile(id){
        let fileToDelete = null;
        this.props.Files.forEach(file => {
            if(file.ID === id){
                fileToDelete = file;
                fileToDelete.action = 'delete';
            }
        })
        if(fileToDelete !== null){
            this.props.collectData(this.props.id, fileToDelete);
        }
    }

    handleFile(file) {
        let read = new FileReader();
        read.readAsDataURL(file);
        let currThis = this;
        read.onloadend = function(){
            if(currThis.fileUploadAllowed(file)){
                let newFile = {
                    'action': 'add',
                    'dataType': 'file',
                    'ID': Date.now(),
                    'Name': file.name,
                    'Size': file.size,
                    'Type': file.type,
                    'Content': read.result,
                }
                currThis.props.collectData(currThis.props.id, newFile);
            }
        }
    }

    fileUploadAllowed(file){
        let allowed = false;
        let formatPassed = false;
        let sizePassed = false;
        let fileCountPassed = false;
        if(this.props.AllowedTypes.some(b => {return b === file.type.toString()})){
            formatPassed = true;
        }
        if(this.props.AllowMultipleFiles){
            let totalSize = 0;
            let fileCount = 0;
            this.props.Files.forEach((uploadedFile) => {
                fileCount++;
                totalSize += uploadedFile.Size;
            })
            if(totalSize < this.props.AllowedMaxSize){
                sizePassed = true;
            }
            fileCountPassed = fileCount < this.props.AllowedMaxFiles;
        } else {
            fileCountPassed = true;
            if(file.size < this.props.AllowedMaxSize){
                sizePassed = true;
            }
        }
        if(sizePassed && formatPassed && fileCountPassed){
            allowed = true;
        }

        this.setState({
            wrongFormat: !formatPassed,
            sizeTooBig: !sizePassed,
            tooManyFiles: !fileCountPassed,
        })
        return allowed;
    }

    handleFileUpload(e, id) {
        let input = document.getElementById(id);
        input.click();
    }

    handleFileInputChange(e){
        if(e.target.files){
            Array.from(e.target.files).forEach((file) => {
                this.handleFile(file);
            })
        }
    }

    renderErrorMessage(){
        let message = '';
        if(!this.props.IsValid){
            message = this.props.ErrorMessage;
        } else if(this.state.tooManyFiles){
            message = this.props.ErrorMessageTooManyFiles;
        } else if(this.state.wrongFormat){
            message = this.props.ErrorMessageWrongFormat;
        } else if(this.state.sizeTooBig){
            message = this.props.ErrorMessageTooBig;
        }
        return(
            <span className="errorMessage">
                {message}
            </span>
        )
    }

    renderUploadedFiles(){
        if(this.props.Files === undefined || this.props.Files.length === 0){
            return null;
        }
        return this.props.Files.map((file, index) => {
            return (
                <div id={this.props.id} className="file__item" key={index}>
                    <span className="file__uploaded">
                        {file.Name}
                    </span>
                    <button type="button" className="delete__icon"  onClick={(e) => {this.deleteFile(file.ID)}}/>
                </div>
            )
        })
    }

    renderDropzoneContent(){
        return (
            <div className="row align-items-center py-3 py-md-4">
                <div className="col-md-3 col-xl-2 text-center">
                    {this.getIcon()}
                </div>
                <div className="col-md-9 col-xl-10 text-center text-md-start">
                    <button type="button" className="font-bold mb-2 ms-0 add__file--button" onClick={(e) => {this.handleFileUpload(e, this.props.id)}}>
                        {this.renderLabelText()}
                    </button>
                    <p className="text-muted mb-0 px-3 px-md-0">
                        {this.props.Hint}
                    </p>
                    {this.renderUploadedFiles()}
                </div>
            </div>
        )
    }

    render(){
        return(
            <div className={this.props.Columns}>
                <div className="upload__field field file mb-3 mb-md-4 mb-xl-5">
                    <input type="file" className="d-none" id={this.props.id} accept={this.props.AllowedTypes} onChange={(e) => {this.handleFileInputChange(e)}}/>
                    <div className="dropzone" onDrop={(e) => this.dropHandler(e)} onDragOver={(e) => this.onDragOver(e)}>
                        {this.renderDropzoneContent()}
                    </div>
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
export default UploadField;